import StartupQuestionnaireService from 'src/modules/userQuestionnaire/startupQuestionnaireService';
import selectors from 'src/modules/userQuestionnaire/startupQuestionnaireSelectors';
import Errors from 'src/modules/shared/error/errors';

const prefix = 'STARTUP_QUESTIONNAIRE';

const startupQuestionnaireActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  RESETED: `${prefix}_RESETED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  doReset: () => async (dispatch) => {
    dispatch({
      type: startupQuestionnaireActions.RESETED,
    });

    dispatch(startupQuestionnaireActions.doFetch());
  },

  doChangePagination:
    (pagination) => async (dispatch, getState) => {
      dispatch({
        type: startupQuestionnaireActions.PAGINATION_CHANGED,
        payload: pagination,
      });

      const filter = selectors.selectFilter(getState());
      const rawFilter = selectors.selectRawFilter(
        getState(),
      );
      dispatch(
        startupQuestionnaireActions.doFetch(
          filter,
          rawFilter,
          true,
        ),
      );
    },

  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({
      type: startupQuestionnaireActions.SORTER_CHANGED,
      payload: sorter,
    });

    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(
      startupQuestionnaireActions.doFetch(
        filter,
        rawFilter,
        true,
      ),
    );
  },

  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: startupQuestionnaireActions.FETCH_STARTED,
          payload: { filter, rawFilter, keepPagination },
        });

        const response =
          await StartupQuestionnaireService.fetch(
            filter,
            selectors.selectOrderBy(getState()),
            selectors.selectLimit(getState()),
            selectors.selectOffset(getState()),
          );

        dispatch({
          type: startupQuestionnaireActions.FETCH_SUCCESS,
          payload: {
            rows: response.rows,
            count: response.count,
          },
        });
      } catch (error) {
        Errors.handle(error);

        dispatch({
          type: startupQuestionnaireActions.FETCH_ERROR,
        });
      }
    },
};

export default startupQuestionnaireActions;
